import {http} from './config';

export default {
    catalog: () => http.get('api/v1/integration-credentials/catalog'),

    index: (params = {}) => http.get('api/v1/integration-credentials', {params}),

    show: id => http.get(`api/v1/integration-credentials/${id}`),

    create: payload => http.post('api/v1/integration-credentials', payload),

    update: payload => http.put(`api/v1/integration-credentials/${payload.id}`, payload),

    delete: id => http.delete(`api/v1/integration-credentials/${id}`),

    validate: id => http.post(`api/v1/integration-credentials/${id}/validate`),
    validatePayload: payload => http.post('api/v1/integration-credentials/validate', payload),
    importAppFacilita: payload => http.post('api/v1/integration-credentials/appfacilita/import', payload),
};
